var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('in-viewport',[_c('div',{staticClass:"projects-section"},[_c('base-layout',[_c('border-box',{attrs:{"slot":"sidebar"},slot:"sidebar"},[_c('h2',[_vm._v("projekty:")]),_vm._v(" "),_c('project-filters-container')],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2)],1)],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00be035a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Projects/ProjectsSection.vue
// module id = null
// module chunks = 